/** A Slack user id: U… (or W… on Enterprise Grid), 7–20 characters. Mirrors the
 *  backend's SLACK_USER_ID_RE, so a bad value is caught before the request. */
export const SLACK_USER_ID_RE = /^[UW][A-Z0-9]{6,19}$/;

export function isValidSlackUserId(value: string): boolean {
  return SLACK_USER_ID_RE.test(value);
}

/** The message a failed request carries, whatever shape the API returned. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && "error" in detail) {
    return String((detail as { error?: unknown }).error || fallback);
  }
  return fallback;
}
